const lang = window.appData && window.appData.lang ? window.appData.lang : 'en'

export function numberFormat (number, unit = false) {  
  let options = {style: 'decimal', minimumFractionDigits: 2}
  if (unit) {
    options.style = 'unit'
    options.unit = unit
  }
  return Intl.NumberFormat(lang, options).format(number)
}

export function dateFormat (date, options = {}) {
  if (typeof date === 'string') {
    date = new Date(date)
  }
  return Intl.DateTimeFormat(lang, options).format(date)
}

export function cleanUrlParam( param ) {
  return param.replace(/\//ig, '__')
}

export function dirtyUrlParam( param ) {
  return param.replace('__', '/')
}

export function setCookie(name, value, seconds = 28800) {
  console.log(name, value)
  const date = new Date()
  date.setTime(date.getTime() + (seconds * 1000))
  document.cookie = `${name}=${value || ''};expires=${date.toUTCString()}; path=/`
}

export function getCookie(name) {
  name = name + '='
  const ca = document.cookie.split(';')
  for (let i = 0, j = ca.length; i < j; i++) {
    let cookie = ca[i]
    while(cookie.charAt(0) == ' ') cookie = cookie.substring(1, cookie.length)
    if (cookie.indexOf(name) == 0) return cookie.substring(name.length, cookie.length)
  }
  return null
}